// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取因子列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /stock-score/factor/list */
export async function stockScoreFactorListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.stockScoreFactorListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockFactorResp>('/stock-score/factor/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 竞价算力股票列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 POST /stock-score/stock-list */
export async function stockScoreStockListUsingPOST(
  body: API.StockScoreReq,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStockScoreResp>('/stock-score/stock-list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
